// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  padding: 0.5em;
}
.shuttle-content {
  padding: 16px 6px 24px;
}
.shuttle-content .shuttle-heading {
  color: var(--eta-color-theme);
  font-size: 24px;
  font-weight: 700;
  margin: 8px 0 6px;
}
.shuttle-content .shuttle-meta {
  color: #333;
  font-size: 15px;
  margin: 0 0 4px;
}
.shuttle-content .shuttle-gps {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  margin: 14px 0 4px;
  padding: 8px 12px;
  border-radius: 10px;
  background-color: var(--etaeta-color-accent);
  color: var(--eta-color-theme);
  font-size: 15px;
  font-weight: 600;
}
.shuttle-content .shuttle-gps span {
  flex: 1;
}
.shuttle-content .shuttle-gps-icon {
  flex-shrink: 0;
  font-size: 16px;
  opacity: 0.65;
}
.shuttle-content .shuttle-gps-chevron {
  flex-shrink: 0;
  font-size: 12px;
  opacity: 0.45;
}
.shuttle-content .shuttle-gps:hover,
.shuttle-content .shuttle-gps:active {
  background-color: var(--etaeta-color-accent-hover);
  color: var(--eta-color-theme);
}
.shuttle-content .shuttle-section {
  margin-top: 20px;
}
.shuttle-content .shuttle-section-title {
  color: var(--eta-color-theme);
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 6px;
}
.shuttle-content .shuttle-entry {
  margin-bottom: 10px;
}
.shuttle-content .shuttle-entry-compact {
  margin-bottom: 2px;
}
.shuttle-content .shuttle-time {
  color: #1f9d57;
  font-weight: 600;
  font-size: 15px;
  margin: 0 0 2px;
}
.shuttle-content .shuttle-lines {
  margin: 0;
  padding-left: 20px;
}
.shuttle-content .shuttle-lines li {
  color: #333;
  font-size: 15px;
  line-height: 1.5;
}
.shuttle-content .shuttle-link {
  color: var(--eta-color-theme);
  text-decoration: underline;
  text-underline-offset: 2px;
}
.shuttle-content .shuttle-link-icon {
  margin-left: 5px;
  font-size: 11px;
  opacity: 0.6;
}
/*# sourceMappingURL=ShuttlePage.css.map */`, "",{"version":3,"sources":["webpack://./ShuttlePage.less","webpack://./src/containers/ShuttlePage/ShuttlePage.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;ACCJ;ADEA;EACI,sBAAA;ACAJ;ADDA;EAIQ,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ACAR;ADPA;EAWQ,WAAA;EACA,eAAA;EACA,eAAA;ACDR;ADZA;EAiBQ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;ACFR;ADzBA;EA8BY,OAAA;ACFZ;ADKQ;EACI,cAAA;EACA,eAAA;EACA,aAAA;ACHZ;ADMQ;EACI,cAAA;EACA,eAAA;EACA,aAAA;ACJZ;ADOQ;;EAEI,kDAAA;EACA,6BAAA;ACLZ;AD3CA;EAqDQ,gBAAA;ACPR;ADSQ;EACI,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACPZ;ADpDA;EAgEQ,mBAAA;ACTR;ADaQ;EACI,kBAAA;ACXZ;AD1DA;EA0EQ,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;ACbR;ADhEA;EAiFQ,SAAA;EACA,kBAAA;ACdR;ADpEA;EAqFY,WAAA;EACA,eAAA;EACA,gBAAA;ACdZ;ADzEA;EA4FQ,6BAAA;EACA,0BAAA;EACA,0BAAA;AChBR;ADkBQ;EACI,gBAAA;EACA,eAAA;EACA,YAAA;AChBZ;AACA,0CAA0C","sourcesContent":[".container {\n    width: 100%;\n    padding: .5em;\n}\n\n.shuttle-content {\n    padding: 16px 6px 24px;\n\n    .shuttle-heading {\n        color: var(--eta-color-theme);\n        font-size: 24px;\n        font-weight: 700;\n        margin: 8px 0 6px;\n    }\n\n    .shuttle-meta {\n        color: #333;\n        font-size: 15px;\n        margin: 0 0 4px;\n    }\n\n    .shuttle-gps {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        min-height: 44px;\n        margin: 14px 0 4px;\n        padding: 8px 12px;\n        border-radius: 10px;\n        background-color: var(--etaeta-color-accent);\n        color: var(--eta-color-theme);\n        font-size: 15px;\n        font-weight: 600;\n\n        span {\n            flex: 1;\n        }\n\n        &-icon {\n            flex-shrink: 0;\n            font-size: 16px;\n            opacity: 0.65;\n        }\n\n        &-chevron {\n            flex-shrink: 0;\n            font-size: 12px;\n            opacity: 0.45;\n        }\n\n        &:hover,\n        &:active {\n            background-color: var(--etaeta-color-accent-hover);\n            color: var(--eta-color-theme);\n        }\n    }\n\n    .shuttle-section {\n        margin-top: 20px;\n\n        &-title {\n            color: var(--eta-color-theme);\n            font-size: 18px;\n            font-weight: 600;\n            margin: 0 0 6px;\n        }\n    }\n\n    .shuttle-entry {\n        margin-bottom: 10px;\n\n        // A period label with no stops of its own sits directly above the\n        // entry it qualifies, so it keeps the tighter gap.\n        &-compact {\n            margin-bottom: 2px;\n        }\n    }\n\n    .shuttle-time {\n        color: #1f9d57;\n        font-weight: 600;\n        font-size: 15px;\n        margin: 0 0 2px;\n    }\n\n    .shuttle-lines {\n        margin: 0;\n        padding-left: 20px;\n\n        li {\n            color: #333;\n            font-size: 15px;\n            line-height: 1.5;\n        }\n    }\n\n    .shuttle-link {\n        color: var(--eta-color-theme);\n        text-decoration: underline;\n        text-underline-offset: 2px;\n\n        &-icon {\n            margin-left: 5px;\n            font-size: 11px;\n            opacity: 0.6;\n        }\n    }\n}\n",".container {\n  width: 100%;\n  padding: 0.5em;\n}\n.shuttle-content {\n  padding: 16px 6px 24px;\n}\n.shuttle-content .shuttle-heading {\n  color: var(--eta-color-theme);\n  font-size: 24px;\n  font-weight: 700;\n  margin: 8px 0 6px;\n}\n.shuttle-content .shuttle-meta {\n  color: #333;\n  font-size: 15px;\n  margin: 0 0 4px;\n}\n.shuttle-content .shuttle-gps {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 44px;\n  margin: 14px 0 4px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background-color: var(--etaeta-color-accent);\n  color: var(--eta-color-theme);\n  font-size: 15px;\n  font-weight: 600;\n}\n.shuttle-content .shuttle-gps span {\n  flex: 1;\n}\n.shuttle-content .shuttle-gps-icon {\n  flex-shrink: 0;\n  font-size: 16px;\n  opacity: 0.65;\n}\n.shuttle-content .shuttle-gps-chevron {\n  flex-shrink: 0;\n  font-size: 12px;\n  opacity: 0.45;\n}\n.shuttle-content .shuttle-gps:hover,\n.shuttle-content .shuttle-gps:active {\n  background-color: var(--etaeta-color-accent-hover);\n  color: var(--eta-color-theme);\n}\n.shuttle-content .shuttle-section {\n  margin-top: 20px;\n}\n.shuttle-content .shuttle-section-title {\n  color: var(--eta-color-theme);\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 6px;\n}\n.shuttle-content .shuttle-entry {\n  margin-bottom: 10px;\n}\n.shuttle-content .shuttle-entry-compact {\n  margin-bottom: 2px;\n}\n.shuttle-content .shuttle-time {\n  color: #1f9d57;\n  font-weight: 600;\n  font-size: 15px;\n  margin: 0 0 2px;\n}\n.shuttle-content .shuttle-lines {\n  margin: 0;\n  padding-left: 20px;\n}\n.shuttle-content .shuttle-lines li {\n  color: #333;\n  font-size: 15px;\n  line-height: 1.5;\n}\n.shuttle-content .shuttle-link {\n  color: var(--eta-color-theme);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.shuttle-content .shuttle-link-icon {\n  margin-left: 5px;\n  font-size: 11px;\n  opacity: 0.6;\n}\n/*# sourceMappingURL=ShuttlePage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
